var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 20,
    viewBox: "0 0 41 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "8.763%",
    y1: "59.473%",
    x2: "104.094%",
    y2: "38.037%",
    id: "ft9h9x55qa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0340",
    offset: ".124%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#074F72",
    offset: "16.29%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#038898",
    offset: "29.91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01ACAF",
    offset: "39.95%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9B8",
    offset: "45.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA6B3",
    offset: "53.93%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D76A5",
    offset: "72.34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B63793",
    offset: "94.71%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-8.471%",
    y1: "21.093%",
    x2: "99.13%",
    y2: "76.752%",
    id: "ytvi9n9z9b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0340",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110543",
    stopOpacity: 0.769,
    offset: "18.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20094A",
    stopOpacity: 0.49,
    offset: "40.07%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381156",
    stopOpacity: 0.186,
    offset: "63.91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B175F",
    stopOpacity: 0,
    offset: "78.53%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-6.063%",
    y1: "62.785%",
    x2: "99.803%",
    y2: "35.338%",
    id: "vq4qrl5swc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0340",
    offset: ".124%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#074F72",
    offset: "16.29%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#038898",
    offset: "29.91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01ACAF",
    offset: "39.95%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9B8",
    offset: "45.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA6B3",
    offset: "53.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D76A5",
    offset: "71.42%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B63793",
    offset: "93.03%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.894 14.94c-2.958.345-5.464-2.002-5.464-4.94a5.01 5.01 0 0 1 1.052-3.078c1.061-1.036 2.226-1.897 3.823-1.897a5.995 5.995 0 0 1 .378.015c.108.01.216.02.324.035.015 0 .03.005.045.005a4.861 4.861 0 0 1 3.341 2.207l5.057-.045-.01-.06a8.562 8.562 0 0 0-2.556-4.71c-.86-.805-1.68-1.146-1.68-1.146a9.53 9.53 0 0 0-1.98-.876h-.005c-.6-.19-1.224-.32-1.868-.39-.024-.005-.054-.005-.078-.01-.148-.015-.3-.025-.452-.035h-.025A7.424 7.424 0 0 0 30.324 0a9.685 9.685 0 0 0-6.403 2.422c-.044.04-.088.075-.132.11a71.735 71.735 0 0 0-3.519 3.359l-.196.2a73.67 73.67 0 0 0-2.9 3.173c-1.17 1.372-3.253 3.439-3.253 3.439-1.12 1.06-2.201 1.731-3.435 1.947-2.815.485-5.513-1.677-5.547-4.59-.035-2.778 2.167-5.04 4.884-5.04 2.182 0 4.025 1.456 4.654 3.463l5.592-5.195V.005h-5.366v1.326A9.614 9.614 0 0 0 9.543.01C4.486.145.28 4.314.015 9.46-.285 15.23 4.22 20 9.818 20a9.651 9.651 0 0 0 4.885-1.326h.005V20h5.36l.006-6.401.304-.316.502-.525C22.054 16.937 25.833 20 30.314 20a9.625 9.625 0 0 0 3.892-.82c.55-.246 1.072-.561 1.573-.902l.034-.025c1.71-1.16 3.017-2.883 3.519-4.915.044-.175.083-.355.113-.535l.01-.05-5.057-.045a4.882 4.882 0 0 1-3.342 2.207l-.162.025z",
    fill: "url(#ft9h9x55qa)",
    transform: "translate(.928)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.894 14.945c-2.958.345-5.464-2.002-5.464-4.945a5.01 5.01 0 0 1 1.052-3.078L22.02 8.584l-1.14 4.174C22.054 16.937 25.833 20 30.314 20a9.625 9.625 0 0 0 3.892-.82l-3.312-4.235z",
    fill: "url(#ytvi9n9z9b)",
    transform: "translate(.928)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.946 9.695-3.116 3.083c-.098.1-.191.2-.29.3-.171.18-.343.36-.52.536a197.618 197.618 0 0 0-3.13 3.313l.01-.04C15.114 18.804 12.594 20 9.793 20 4.384 20 0 15.536 0 10.025c0 0 5.892 4.7 9.651 4.71 1.081 0 2.383-.49 3.238-1.171.36-.286.698-.576 1.018-.866.01-.005.02-.02.034-.03.34-.34 2.138-2.137 3.184-3.374a70.288 70.288 0 0 1 2.895-3.168l.196-.2.05-.035a69.59 69.59 0 0 1 3.518-3.358c.044-.04.088-.076.132-.11A9.66 9.66 0 0 1 30.32 0c.158 0 .315.01.472.015h.025c.152.01.3.02.452.035.024.005.054.005.078.01.644.07 1.268.2 1.868.39h.005a9.53 9.53 0 0 1 1.98.876s.82.34 1.68 1.146a8.549 8.549 0 0 1 2.556 4.71l.01.06-5.057.045a4.882 4.882 0 0 0-3.341-2.207c-.015 0-.03-.005-.045-.005-.108-.015-.21-.03-.324-.035-.024 0-.054-.005-.079-.005a5.804 5.804 0 0 0-.3-.01c-.2 0-.407.02-.618.05-1.19.18-2.266.82-3.086 1.717l-2.65 2.903z",
    fill: "url(#vq4qrl5swc)",
    transform: "translate(.928)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAc);
export default __webpack_public_path__ + "static/media/logo-ac.cbb3a329fef89cc5317df2f7167daf4b.svg";
export { ForwardRef as ReactComponent };